<template>
  <div v-show="show" class="overLay mack">
    <div class="wrapper">
      <img :src="iconLoading" alt />
      <p>加载中...</p>
    </div>
  </div>
</template>
<script>
export default {
  name:'Loading',
  props:{
    show:{
      default:true,
      type:Boolean
    }
  },
  data() {
    return {
      iconLoading: require('@/assets/loading.gif')
    }
  },
  created() {
    // if(localStorage.getItem('skinTheme')){
    //   this.iconLoading = JSON.parse(localStorage.getItem('skinTheme')).u_page_icon_line;
    // }
  },

  
};
</script>
<style lang="less" scoped>
.overLay {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  width: 100%;
  height: 100%;
  background-color: rgba(10, 10, 10, 0.1);
}
.mack {
  background: rgba(10, 10, 10, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  .wrapper {
    background: rgba(0, 0, 0, 0.5);
    width: 120px;
    height: 120px;
    font-size: 20px;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    border-radius: 10px;
    img {
      width: 60px;
    }
  }
}
</style>